__turbopack_context__.v({
  "avatarContainer": "AvatarComponent-module-scss-module__YhezVG__avatarContainer",
  "avatarWithBadge": "AvatarComponent-module-scss-module__YhezVG__avatarWithBadge",
  "badge": "AvatarComponent-module-scss-module__YhezVG__badge",
  "customAvatar": "AvatarComponent-module-scss-module__YhezVG__customAvatar",
  "large": "AvatarComponent-module-scss-module__YhezVG__large",
  "small": "AvatarComponent-module-scss-module__YhezVG__small",
});
